import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { ProductDetail } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        AuthProductCode: '',
        GPI14: '',
        NDC: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "AuthProductCode",
        collectionName: "PA Product"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        AuthProductCode: false,
        GPI14: false,
        NDC: false
    }
}

export const getProductDetailsData = createAsyncThunk('data/getProductDetailsData',
    async (data, { rejectWithValue }) => {
        try {
            let queryProductDetails =
                `query GetPriorAuthProductDetails{
                    GetPriorAuthProductDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"PA Product",
                isDownload:false,
                ${data.AuthProductCode ? `,authproductcode: "${data.AuthProductCode}"` : ""}
                ${data.GPI14 ? `,gpi14: "${data.GPI14}"` : ""}
                ${data.NDC ? `,nationaldrugcode: "${data.NDC}"` : ""}
                `;

            queryProductDetails += ProductDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryProductDetails, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getProductDetailsDownloadAll = createAsyncThunk('data/getProductDetailsDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryProductDetailAll =
                `query GetPriorAuthProductDetails{
                    GetPriorAuthProductDetails(
                    collectionName:"PA Product",
                    isDownload:true,
                ${data.AuthProductCode ? `,authproductcode: "${data.AuthProductCode}"` : ""}
                ${data.GPI14 ? `,gpi14: "${data.GPI14}"` : ""}
                ${data.NDC ? `,nationaldrugcode: "${data.NDC}"` : ""}
                `;

            queryProductDetailAll += ProductDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryProductDetailAll, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const productDetailSlice = createSlice({
    name: 'productDetail',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProductDetailsData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getProductDetailsData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetPriorAuthProductDetails.totalCount;
                state.data.tableData = response.data.data.GetPriorAuthProductDetails.data;
            })
            .addCase(getProductDetailsData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getProductDetailsDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getProductDetailsDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.tableData = response.data.data.GetPriorAuthProductDetails.data;
            })
            .addCase(getProductDetailsDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = productDetailSlice.actions;
export default productDetailSlice.reducer